import React from "react";

import imgSteelFrame from "../assets/images/project11.jpg.webp";
import imgDryConstruct from "../assets/images/project9.jpg.webp";
import imgMFCeilings from "../assets/images/project17.jpg.webp";
import imgPartitions from "../assets/images/project10.jpg.webp";
import imgInsulation from "../assets/images/project15.jpg.webp";
import imgReairs from "../assets/images/project20.jpg.webp";


const services = [
    {
        title: "Steel Frame",
        image: imgSteelFrame,
        paragraphs: [
            "Light Gauge Steel Framing is a revolutionary dry construction system that prioritizes structural precision and industrial efficiency over traditional methods. By utilizing cold-formed galvanized steel profiles, this technology enables architects to execute complex designs with millimetric accuracy while cutting construction timelines by more than half. This streamlined workflow eliminates on-site waste, ensuring a cleaner, more organized, and highly predictable building environment for modern developers.",
        ],
    },
    {
        title: "Dry Construction",
        image: imgDryConstruct,
        paragraphs: [
            "The benefits extend far beyond speed, offering a significant reduction in structural weight and a massive decrease in construction waste. These systems provide exceptional versatility for interior layouts, allowing for easy maintenance and future renovations without the mess of conventional demolition. Furthermore, the intelligent layering of materials creates a powerful thermal and acoustic barrier, resulting in energy-efficient buildings that prioritize occupant comfort and long-term sustainability.",
        ],
    },
    {
        title: "MF Ceilings",
        image: imgMFCeilings,
        paragraphs: [
            "This service includes a variety of options, from simple and elegant designs to intricate, custom-made features, integrating advanced materials for durability, fire resistance, and acoustic management.",
            "It focuses on creating visually appealing spaces that also contribute to the energy efficiency and comfort of the environment through careful material selection and the integration of lighting and insulation.",

        ],
    },
    {
        title: "Partitions",
        image: imgPartitions,
        paragraphs: [
            "This service caters to both commercial and residential settings, offering solutions that range from fixed, permanent walls to flexible, movable panels.",
            "The versatility of partitions allows for the creation of distinct areas within a larger space, such as workstations in offices, private rooms in homes, or secluded areas in retail environments, without the need for structural alterations to the building.",
        ],
    },
    {
        title: "Airtight Solutions",
        image: imgInsulation,
        paragraphs: [
            "Implementing airtight solutions requires a meticulous approach, combining advanced technology and materials with skilled workmanship. ",
            "Solutions are customized to the specific needs and structure of the building, taking into consideration factors like building materials, architectural features, and the local climate.",
            "The goal is to achieve an optimal balance between airtightness and ventilation, enhancing the building's energy performance and occupant comfort.",

        ],
    },


    {
        title: "Ceilings and partitions Repairs",
        image: imgReairs,
        paragraphs: [
            "We specialize in small-scale repairs and the maintenance of ceilings and partitions. Our team provides fast, reliable solutions for cracks, water damage, and structural touch-ups in your home or office. ",
            " From fixing minor drywall holes to restoring ceiling linings, we ensure a seamless and professional finish. We take pride in our attention to detail, making sure every repair is virtually invisible.",
            ".Trust us to keep your interiors looking flawless with high-quality materials and efficient service.",

        ],
    },



];

const styles = {
    section: {
        backgroundColor: "#0e66ad",
        padding: "60px 40px",
        fontFamily: "'Segoe UI', Arial, sans-serif",
    },
    heading: {
        textAlign: "center",
        fontSize: "2rem",
        fontWeight: "700",
        marginBottom: "48px",
        marginTop: "0",
        color: "#fdfdfd",
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        gap: "24px",
        maxWidth: "1200px",
        margin: "0 auto",
    },
    card: {
        backgroundColor: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
    },
    cardImage: {
        width: "100%",
        height: "220px",
        objectFit: "cover",
        display: "block",
    },
    cardBody: {
        padding: "28px 28px 40px",
        flex: 1,
    },
    cardTitle: {
        fontSize: "1.2rem",
        fontWeight: "700",
        color: "#111",
        marginBottom: "16px",
        marginTop: "0",
    },
    cardSubtitle: {
        fontSize: "1rem",
        fontWeight: "600",
        color: "#333",
        marginTop: "0",
        marginBottom: "16px",
    },
    cardText: {
        fontSize: "0.93rem",
        color: "#444",
        lineHeight: "1.75",
        marginBottom: "12px",
        marginTop: "0",
    },
};

export default function Services() {
    return (
        <section id="services" style={styles.section}>
            <h2 style={styles.heading}>Our Services</h2>
            <div style={styles.grid}>
                {services.map((service, index) => (
                    <div style={styles.card} key={index}>
                        <img
                            src={service.image}
                            alt={service.title}
                            style={styles.cardImage}
                            width="280"
                            height="220"
                            loading="lazy"
                            decoding="async"
                        />
                        <div style={styles.cardBody}>
                            <h3 style={styles.cardTitle}>{service.title}</h3>
                            <h4 style={styles.cardSubtitle}>Professional dry construction solutions for every room</h4>
                            {service.paragraphs.map((para, i) => (
                                <p key={i} style={styles.cardText}>{para}</p>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}